import { Tooltip } from 'antd';
import { ColumnsType } from 'antd/es/table';
import React from 'react';
import { localize } from '/react4xp/mixins/helpers';

export interface DataType {
    key: React.Key;
}

export const selfRegulatorySro = (translations: Record<string, any>): ColumnsType<DataType> => [
    {
        title: localize('register-sro.col-0', translations),
        dataIndex: 'entryNumber',
        align: 'center',
    },
    {
        title: localize('register-sro.col-1', translations),
        dataIndex: 'dateOfEnteringInformation',
        render: (dateOfEnteringInformation) =>
            dateOfEnteringInformation &&
            dateOfEnteringInformation.substring(0, 10).split('-').reverse().join('.'),
    },
    {
        title: localize('register-sro.name-sro', translations),
        dataIndex: 'name',
    },
    {
        title: localize('register-sro.information-membership', translations),
        dataIndex: 'membershipInformationVoluntaryOrCompulsory',
    },
    {
        title: localize('register-sro.col-4', translations),
        dataIndex: 'stateFunction',
        render: (value) => (
            <Tooltip
                placement="topLeft"
                title={value}
            >
                {value}
            </Tooltip>
        ),
    },
    {
        title: localize('register-sro.col-5', translations),
        dataIndex: 'charter',
        ellipsis: {
            showTitle: false,
        },
        render: (value) => (
            <Tooltip
                placement="topLeft"
                title={value}
            >
                {value}
            </Tooltip>
        ),
    },
    {
        title: localize('register-sro.col-6', translations),
        dataIndex: 'approvedRules',
        render: (value) => (
            <Tooltip
                placement="topLeft"
                title={value}
            >
                {value}
            </Tooltip>
        ),
    },
    {
        title: localize('register-sro.col-7', translations),
        dataIndex: 'approvedStandards',
        render: (value) => (
            <Tooltip
                placement="topLeft"
                title={value}
            >
                {value}
            </Tooltip>
        ),
    },
    {
        title: localize('register-sro.col-8', translations),
        dataIndex: 'propertyLiability',
        render: (value) => (
            <Tooltip
                placement="topLeft"
                title={value}
            >
                {value}
            </Tooltip>
        ),
    },
    {
        title: localize('register-sro.col-9', translations),
        children: [
            {
                title: localize('register-sro.col-9-children-0', translations),
                dataIndex: 'mandatoryContributionsType',
                ellipsis: {
                    showTitle: false,
                },
                render: (value) => (
                    <Tooltip
                        placement="topLeft"
                        title={value}
                    >
                        {value}
                    </Tooltip>
                ),
            },
            {
                title: localize('register-sro.col-9-children-1', translations),
                dataIndex: 'mandatoryContributionsProportions',
                ellipsis: {
                    showTitle: false,
                },
                render: (value) => (
                    <Tooltip
                        placement="topLeft"
                        title={value}
                    >
                        {value}
                    </Tooltip>
                ),
            },
        ],
    },
    {
        title: localize('register-sro.col-10', translations),
        children: [
            {
                title: localize('register-sro.col-10-children-0', translations),
                dataIndex: 'kindOfActivity',
                render: (value) => (
                    <Tooltip
                        placement="topLeft"
                        title={value}
                    >
                        {value}
                    </Tooltip>
                ),
            },
            {
                title: localize('register-sro.col-10-children-1', translations),
                dataIndex: 'endDate',
                children: [
                    {
                        title: localize('register-sro.col-10-children-1-grandchildren-0', translations),
                        dataIndex: 'fioIndividuals',
                        ellipsis: {
                            showTitle: false,
                        },
                        render: (value) => (
                            <Tooltip
                                placement="topLeft"
                                title={value}
                            >
                                {value.split('\n').length - 1 + ' записей'}
                            </Tooltip>
                        ),
                    },
                ],
            },
            {
                title: localize('register-sro.col-10-children-2', translations),
                dataIndex: 'endDate',
                children: [
                    {
                        title: localize('register-sro.col-10-children-2-grandchildren-0', translations),
                        dataIndex: 'taxpayerCodeEntrepreneur',
                        render: (value) => (
                            <Tooltip
                                placement="topLeft"
                                title={value}
                            >
                                {value}
                            </Tooltip>
                        ),
                    },
                ],
            },
            {
                title: localize('register-sro.col-10-children-3', translations),
                dataIndex: 'endDate',
                children: [
                    {
                        title: localize('register-sro.col-10-children-3-grandchildren-0', translations),
                        dataIndex: 'organizationalAndLegalFormOfLegalEntity',
                        render: (value) => (
                            <Tooltip
                                placement="topLeft"
                                title={value}
                            >
                                {value}
                            </Tooltip>
                        ),
                    },
                    {
                        title: localize('register-sro.col-10-children-3-grandchildren-1', translations),
                        dataIndex: 'binOfLegalEntity',
                        render: (value) => (
                            <Tooltip
                                placement="topLeft"
                                title={value}
                            >
                                {value}
                            </Tooltip>
                        ),
                    },
                    {
                        title: localize('register-sro.col-10-children-3-grandchildren-2', translations),
                        dataIndex: 'addressOfLegalEntity',
                        render: (value) => (
                            <Tooltip
                                placement="topLeft"
                                title={value}
                            >
                                {value}
                            </Tooltip>
                        ),
                    },
                ],
            },
            {
                title: localize('register-sro.col-10-children-4 ', translations),
                dataIndex: 'website',
            },
            {
                title: localize('register-sro.col-10-children-5', translations),
                dataIndex: 'terminatedMembership',
            },
            {
                title: localize('register-sro.col-10-children-6', translations),
                dataIndex: 'otherInformation',
            },
        ],
    },
];
